import { Card, CardBody, Col, Row } from "reactstrap";
import { SeccionSalir } from "./ComponentPolizas";
import React, { useEffect, useState } from "react";
import buscar from "../assets/img/icon/icon_buscar.svg";
import * as htmlToImage from "html-to-image";
import descargar from "../assets/img/icon/icon_descargar.svg";
import { ModalCargando } from "../coms/ModalCargando";
import { ListRedes } from "./utils";

export const ResultadoFiltro = ({ tp, red, redCoberturas = [], ciudad, listFiltro = [], setShowResults }) => {
    {
        /*
    listFiltro --> [red, listaBeneficios]
    red --> red ambulatoria, etc
    tipored --> padimeg, etc
    */
    }
    const [beneficios, setBeneficios] = useState([]);
    const [tipoRed, setTipoRed] = useState({}); // tipo red seleccionada
    const [espere, setEspere] = useState(false);

    useEffect(() => {
        handleBeneficiosByTipoRed(listFiltro[0][0]); // para escoger el 1er item por defecto
    }, []);

    function print(id) {
        setEspere(true);
        setTimeout(() => {
            var node = document.getElementById(id);
            htmlToImage
                .toPng(node, { quality: 0.95 })
                .then(dataUrl => {
                    const link = document.createElement("a");
                    link.download = "imagen-beneficio.jpg";
                    link.href = dataUrl;
                    link.click();
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => setEspere(false));
        }, [1000]);
    }

    const handleBeneficiosByTipoRed = idRed => {
        if (idRed) {
            handleTipoRed(idRed);
            const lista = listFiltro.find(b => b[0] == idRed);
            setBeneficios(lista[1]);
        }
    };

    const handleTipoRed = idRed => {
        const tipo = redCoberturas?.find(r => r.id == idRed);
        setTipoRed(tipo);
    };

    return (
        <>
            <div className="content">
                <div className="container-fluid ml-md-5">
                    <Card className={"resultados__filtro"}>
                        <div className="card-header">
                            <div className="row justify-content-end">
                                <SeccionSalir to={"/" + tp + "/polizas"} />
                            </div>
                            <div className="container">
                                <div className="row justify-content-between align-items-end">
                                    <div className="col-md-5 mb-2 mb-md-4">
                                        <label className={"font-medium"}>{"Seleccionar tipo de Red:"}</label>
                                        <select
                                            className="form-control primary bg-yellow-light font-medium text-primary"
                                            onChange={e => handleBeneficiosByTipoRed(e.target.value)}
                                        >
                                            {(listFiltro || []).map((a, idx) => (
                                                <option className={"font-medium"} key={idx} value={a[0]}>
                                                    {redCoberturas.find(r => r.id == a[0])?.red}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col mb-2 mb-md-4 beneficios">
                                        <div className="beneficios__buscar-no-line">
                                            <button
                                                type={"button"}
                                                className={"btn beneficios__btn"}
                                                onClick={() => setShowResults(false)}
                                            >
                                                <img src={buscar} alt="" width={"15"} />
                                                &nbsp;
                                                <span>Nueva Búsqueda</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CardBody>
                            <div className="container">
                                <div className="row my-3">
                                    <div className="col-md-8">
                                        <h5 className={"mb-4 text-primary"}>{tipoRed?.red || ""}</h5>
                                        {tipoRed?.descripcion && (
                                            <div>
                                                <span className={"subtitulos-color font-medium"}>
                                                    Beneficios de la red
                                                </span>
                                                <br />
                                                <span className={"text-primary"}>{tipoRed.descripcion}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col text-right">
                                        <h5 className="text-primary">Resultados:</h5>
                                        <span className="sub-titulos">
                                            {listFiltro?.length || 0} tipo de redes encontradas{" "}
                                            <b>{ciudad && `en ${ciudad}`}</b>
                                        </span>
                                    </div>
                                </div>
                                <div className="row vertical-scroll">
                                    {(beneficios || []).map((beneficio, idx) => (
                                        <Col key={idx} lg={6} id={"ben" + beneficio.cdBeneficio}>
                                            <div
                                                className={"borde--height"}
                                                style={{
                                                    minHeight: `${beneficio.red === ListRedes.find(l => l.letra === "S").id ? "220px" : ""}`,
                                                }}
                                            >
                                                <div className={"col-lg-12 beneficios__seccion"}>
                                                    <span>
                                                        <span className={"d-none d-md-inline-block"}>{""}</span>
                                                        <b className={"ml-2"}>{tipoRed.red}</b>
                                                    </span>
                                                    <ButtonDescargar
                                                        className={"d-none d-md-block"}
                                                        beneficio={beneficio}
                                                        print={print}
                                                        espere={espere}
                                                    />
                                                </div>
                                                <div className={""}>
                                                    <Row>
                                                        <Col md={12}>
                                                            <Row className={"font-medium-title container"}>
                                                                <div className={"col-12 text-center my-3"}>
                                                                    <h6 className="subtitulos-color">
                                                                        {beneficio.red}
                                                                    </h6>
                                                                </div>
                                                                <div className={"col-lg-4 text-primary"}>
                                                                    <span>{"Especialidad: "}</span>
                                                                </div>
                                                                <div className={"col-lg-8"}>
                                                                    {beneficio.especialidad}
                                                                </div>
                                                                {beneficio.red !==
                                                                ListRedes.find(l => l.letra === "S").id ? (
                                                                    <>
                                                                        <div className={"col-lg-4 text-primary"}>
                                                                            <span className={""}>{"Proveedor: "}</span>
                                                                        </div>
                                                                        <div className={"col-lg-8"}>
                                                                            {beneficio.nombreProveedor}
                                                                        </div>
                                                                        {beneficio.red !==
                                                                        ListRedes.find(l => l.letra === "F").id ? (
                                                                            <>
                                                                                <div
                                                                                    className={"col-lg-4 text-primary"}
                                                                                >
                                                                                    <span className={""}>
                                                                                        {"Médico: "}
                                                                                    </span>
                                                                                </div>
                                                                                <div className={"col-lg-8"}>
                                                                                    {beneficio.nombre}
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <div
                                                                                    className={"col-lg-4 text-primary"}
                                                                                >
                                                                                    <span className={""}>
                                                                                        {"Punto de Venta: "}
                                                                                    </span>
                                                                                </div>
                                                                                <div className={"col-lg-8"}>
                                                                                    {beneficio.puntoVenta}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        <div className={"col-lg-4 text-primary"}>
                                                                            <span className={""}>{"Ciudad: "}</span>
                                                                        </div>
                                                                        <div className={"col-lg-8"}>
                                                                            {beneficio.ciudad}
                                                                        </div>
                                                                        <div className={"col-lg-4 text-primary"}>
                                                                            <span className={""}>{"Dirección: "}</span>
                                                                        </div>
                                                                        <div className={"col-lg-8"}>
                                                                            {beneficio.direccion}
                                                                        </div>
                                                                        <div className={"col-lg-4 text-primary"}>
                                                                            <span className={""}>{"Teléfono: "}</span>
                                                                        </div>
                                                                        <div className={"col-lg-8"}>
                                                                            {beneficio.telefono}
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className={"col-lg-4 text-primary"}>
                                                                            <span className={""}>{"Protocolo: "}</span>
                                                                        </div>
                                                                        <div className={"col-lg-8"}>
                                                                            {beneficio.protocolo}
                                                                        </div>
                                                                        <div className={"col-lg-4 text-primary"}>
                                                                            <span className={""}>{"Paquete: "}</span>
                                                                        </div>
                                                                        <div className={"col-lg-8"}>
                                                                            {beneficio.paquete}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <div className="col-12 mt-2 text-right">
                                                                    <ButtonDescargar
                                                                        className={"d-block d-md-none"}
                                                                        beneficio={beneficio}
                                                                        print={print}
                                                                        espere={espere}
                                                                    />
                                                                </div>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <br />
                                            </div>
                                        </Col>
                                    ))}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
            <ModalCargando
                open={espere}
                title={"Descargando Beneficio"}
                subtitule={"Por favor espere, descargando..."}
            />
        </>
    );
};

const ButtonDescargar = ({ espere, print, beneficio, ...props }) => {
    return (
        <div className={props?.className || ""}>
            {!espere && (
                <button className={"beneficios__btn"} onClick={() => print("ben" + beneficio.cdBeneficio)}>
                    {"Guardar Imagen"}
                    &nbsp;
                    <img src={descargar} width={"15"} />
                </button>
            )}
        </div>
    );
};
